import { Component, OnInit } from '@angular/core';
import { Customer, Unit, UserDetailsMainModel } from 'src/app/user-details-model';
import { AppServiceService } from 'src/app/app-service.service';
import { UserModel } from 'src/app/product-config-admin/product-config';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {
  isProdConfig: boolean = false;
  userDetails: UserDetailsMainModel;
  selectedCustomer: Customer;
  selectedUnit: Unit;
  lstUsers: UserModel[] = [];
  profileData: any = {
    userName: '',
    email: '',
    units: '',
    roles: ''
  };
  constructor(private appService: AppServiceService, private service: CommonService) { }

  ngOnInit(): void {
    // this.appService.selectedCustomer.subscribe(d => this.selectedCustomer = d);
    // this.appService.selectedUnit.subscribe(d => this.selectedUnit = d);
    this.profileData = {
      userName: '',
      email: '',
      units: '',
      roles: ''
    }
    
    this.appService.userDetails.subscribe(data => {
      this.userDetails = data;
      if (data.usersData != null) {
        this.profileData.userName = data.usersData.userName;
        this.profileData.email = data.usersData.email;
      }

      if (data.units.length > 0) {
        this.profileData.units = data.units.map(a => a.unitName).join(',');
      }

      if (data.roles.length > 0) {
        this.profileData.roles = data.roles.map(a => a.roleName).join(',');
      }


    });
    
  }

}
